/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ id: NonNullable<unknown> }} Home_Pulse_Title_Achievementsid1Inputs */

const id_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pencapaian ${i?.id}`)
};

const ms_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pencapaian ${i?.id}`)
};

const da_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Achievements ${i?.id}`)
};

const de_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errungenschaften ${i?.id}`)
};

const en_us2_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Achievements ${i?.id}`)
};

const es_es2_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Logros ${i?.id}`)
};

const es_mx2_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Logros ${i?.id}`)
};

const fil_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Achievements ${i?.id}`)
};

const fr_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Succès ${i?.id}`)
};

const it_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Risultati ${i?.id}`)
};

const hu_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Teljesítmények ${i?.id}`)
};

const nl_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prestaties ${i?.id}`)
};

const no_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prestasjoner ${i?.id}`)
};

const pl_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Osiągnięcia ${i?.id}`)
};

const pt_br2_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conquistas ${i?.id}`)
};

const pt_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conquistas ${i?.id}`)
};

const ro_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Realizări ${i?.id}`)
};

const fi_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Saavutukset ${i?.id}`)
};

const sv_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prestationer ${i?.id}`)
};

const vi_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Thành tích ${i?.id}`)
};

const tr_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Başarımlar ${i?.id}`)
};

const cs_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Úspěchy ${i?.id}`)
};

const bg_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Постижения ${i?.id}`)
};

const ru_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Достижения ${i?.id}`)
};

const uk_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Досягнення ${i?.id}`)
};

const ar_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`الإنجازات ${i?.id}`)
};

const hi_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`उपलब्धियाँ ${i?.id}`)
};

const th_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ความสำเร็จ ${i?.id}`)
};

const ja_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`実績 ${i?.id}`)
};

const zh_cn2_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`成就 ${i?.id}`)
};

const zh_hant1_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`成就 ${i?.id}`)
};

const ko_home_pulse_title_achievementsid1 = /** @type {(inputs: Home_Pulse_Title_Achievementsid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`도전 과제 ${i?.id}`)
};

/**
* | output |
* | --- |
* | "Achievements {id}" |
*
* @param {Home_Pulse_Title_Achievementsid1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_pulse_title_achievementsid1 = /** @type {((inputs: Home_Pulse_Title_Achievementsid1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pulse_Title_Achievementsid1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_pulse_title_achievementsid1(inputs)
	if (locale === "ms") return ms_home_pulse_title_achievementsid1(inputs)
	if (locale === "da") return da_home_pulse_title_achievementsid1(inputs)
	if (locale === "de") return de_home_pulse_title_achievementsid1(inputs)
	if (locale === "en-US") return en_us2_home_pulse_title_achievementsid1(inputs)
	if (locale === "es-ES") return es_es2_home_pulse_title_achievementsid1(inputs)
	if (locale === "es-MX") return es_mx2_home_pulse_title_achievementsid1(inputs)
	if (locale === "fil") return fil_home_pulse_title_achievementsid1(inputs)
	if (locale === "fr") return fr_home_pulse_title_achievementsid1(inputs)
	if (locale === "it") return it_home_pulse_title_achievementsid1(inputs)
	if (locale === "hu") return hu_home_pulse_title_achievementsid1(inputs)
	if (locale === "nl") return nl_home_pulse_title_achievementsid1(inputs)
	if (locale === "no") return no_home_pulse_title_achievementsid1(inputs)
	if (locale === "pl") return pl_home_pulse_title_achievementsid1(inputs)
	if (locale === "pt-BR") return pt_br2_home_pulse_title_achievementsid1(inputs)
	if (locale === "pt") return pt_home_pulse_title_achievementsid1(inputs)
	if (locale === "ro") return ro_home_pulse_title_achievementsid1(inputs)
	if (locale === "fi") return fi_home_pulse_title_achievementsid1(inputs)
	if (locale === "sv") return sv_home_pulse_title_achievementsid1(inputs)
	if (locale === "vi") return vi_home_pulse_title_achievementsid1(inputs)
	if (locale === "tr") return tr_home_pulse_title_achievementsid1(inputs)
	if (locale === "cs") return cs_home_pulse_title_achievementsid1(inputs)
	if (locale === "bg") return bg_home_pulse_title_achievementsid1(inputs)
	if (locale === "ru") return ru_home_pulse_title_achievementsid1(inputs)
	if (locale === "uk") return uk_home_pulse_title_achievementsid1(inputs)
	if (locale === "ar") return ar_home_pulse_title_achievementsid1(inputs)
	if (locale === "hi") return hi_home_pulse_title_achievementsid1(inputs)
	if (locale === "th") return th_home_pulse_title_achievementsid1(inputs)
	if (locale === "ja") return ja_home_pulse_title_achievementsid1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_pulse_title_achievementsid1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_pulse_title_achievementsid1(inputs)
	return ko_home_pulse_title_achievementsid1(inputs)
});
export { home_pulse_title_achievementsid1 as "home.pulse.title.achievementsId" }